import fetch from '@/utils/fetch'

export function getConst(md5) {
  return fetch({
    url: '/yaf_sys/const/listallcache/' + md5,
    method: 'get'
  })
}



// WEBPACK FOOTER //
// ./src/api/const.js